import { Button, Col, Form, FormControl, InputGroup, Row } from "react-bootstrap";
import { focusInput, focusoutInput } from "./utils";
import Icon from 'components/Icon';

interface Params{
  move: Function,
}

export default function FormForgotPassword({move}:Params){
  return (
    <Form>
      <Row>
        <h2>Esqueceu a senha</h2>
        <Col xs="12" className="mt-2">
          <Form.Label htmlFor="mail" >
            E-mail
          </Form.Label>
          <InputGroup className="mb-2">
            <InputGroup.Text className="input-icon"><Icon name="at"/></InputGroup.Text>
            <FormControl id="forgot-pass-mail" placeholder="E-mail" type="email"
              onFocus={({target})=>focusInput(target)}
              onBlur={({target})=>focusoutInput(target)}
            />
          </InputGroup>
        </Col>
        <Form.Group className="col-auto mb-3" style={{fontSize: `14px`}}>
          <Form.Label id="return-login-btn" onClick={()=>move()}>Voltar para o login
            <div id="icon-return-login-btn"><Icon name="chevron-left"/></div>
          </Form.Label>
        </Form.Group>

        <Col xs="12" className="mt-3 center">
          <Button className="w-100">Lembrar acesso</Button>
        </Col>
      </Row>
    </Form>
  )
}